// extracted by mini-css-extract-plugin
export default {"inboxNavLinks":"InboxNavLinks_inboxNavLinks__ygYbT","active":"InboxNavLinks_active__sLKrf"};